import capitalize from 'lodash/capitalize';

export function formatData(value: string, format: string) {
  if (!format || !value) return value;
  switch (format) {
    case 'uppercase':
      return value.toUpperCase();
    case 'lowercase':
      return value.toLowerCase();
    case 'capitalize':
      return value.replace(/([0-9A-Za-z_À-ÿ]+)/g, (word) => capitalize(word));
    default:
      return value;
  }
}
